export default (state = {}, action = {}) => {
  switch(action.type) {
    case 'FETCH_SETTINGS':
      return action.payload
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/settings.js